import React from 'react';
import PropTypes from 'prop-types';

const DeleteStep = ({ onDelete, step }) => (
  <button id={`step-${step}-delete-field-btn`} type="button" className="float-sm-right" style={{ fontSize: '14px', color: '#282828', lineHeight: 1 }} onClick={() => onDelete(step)}>
    <svg fill="#000000" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
      <title>Delete</title>
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
    <span style={{ verticalAlign: 'middle' }}>Delete</span>
  </button>

);
DeleteStep.propTypes = {
  onDelete: PropTypes.func.isRequired,
  step: PropTypes.string.isRequired,
};

export default DeleteStep;
